const RUNTIME_HTTP_ORIGIN =
  typeof window !== "undefined" ? window.location.origin : "https://boopboop.me";
const RUNTIME_WS_ORIGIN = RUNTIME_HTTP_ORIGIN.replace(/^http/, "ws");

function isLocalEndpoint(url: string | undefined) {
  if (!url) return false;
  return /^https?:\/\/(?:127\.0\.0\.1|localhost)(?::\d+)?(?:\/|$)/i.test(url);
}

function isLocalWsEndpoint(url: string | undefined) {
  if (!url) return false;
  return /^wss?:\/\/(?:127\.0\.0\.1|localhost)(?::\d+)?(?:\/|$)/i.test(url);
}

const configuredApiUrl =
  (import.meta.env.DEV ? import.meta.env.VITE_DEV_API_URL : undefined) ??
  (import.meta.env.VITE_API_URL as string);
const configuredWsUrl =
  (import.meta.env.DEV ? import.meta.env.VITE_DEV_WS_URL : undefined) ??
  (import.meta.env.VITE_WS_URL as string);
const configuredMediaUrl =
  (import.meta.env.DEV ? import.meta.env.VITE_DEV_MEDIA_URL : undefined) ??
  (import.meta.env.VITE_MEDIA_URL as string);
const configuredProxyUrl =
  (import.meta.env.DEV ? import.meta.env.VITE_DEV_PROXY_URL : undefined) ??
  (import.meta.env.VITE_PROXY_URL as string);

const shouldOverrideApiInProd =
  import.meta.env.PROD && isLocalEndpoint(configuredApiUrl);
const shouldOverrideWsInProd =
  import.meta.env.PROD && isLocalWsEndpoint(configuredWsUrl);
const shouldOverrideMediaInProd =
  import.meta.env.PROD && isLocalEndpoint(configuredMediaUrl);
const shouldOverrideProxyInProd =
  import.meta.env.PROD && isLocalEndpoint(configuredProxyUrl);

const DEFAULT_API_URL = shouldOverrideApiInProd
  ? `${RUNTIME_HTTP_ORIGIN}/api`
  : configuredApiUrl ?? `${RUNTIME_HTTP_ORIGIN}/api`;

export default {
  /**
   * Whether to emit additional debug information
   */
  DEBUG: import.meta.env.DEV || true,
  /**
   * What API server to connect to by default.
   */
  DEFAULT_API_URL,
  /**
   * Whether this is Stoat
   */
  IS_STOAT: ["https://boopboop.me/api", `${RUNTIME_HTTP_ORIGIN}/api`].includes(
    DEFAULT_API_URL,
  ),
  /**
   * What WS server to connect to by default.
   */
  DEFAULT_WS_URL: shouldOverrideWsInProd
    ? `${RUNTIME_WS_ORIGIN}/ws`
    : configuredWsUrl ?? `${RUNTIME_WS_ORIGIN}/ws`,
  /**
   * What media server to connect to by default.
   */
  DEFAULT_MEDIA_URL: shouldOverrideMediaInProd
    ? `${RUNTIME_HTTP_ORIGIN}/autumn`
    : configuredMediaUrl ?? `${RUNTIME_HTTP_ORIGIN}/autumn`,
  /**
   * What proxy server to connect to by default.
   */
  DEFAULT_PROXY_URL: shouldOverrideProxyInProd
    ? `${RUNTIME_HTTP_ORIGIN}/january`
    : configuredProxyUrl ?? `${RUNTIME_HTTP_ORIGIN}/january`,
  /**
   * hCaptcha site key to use if enabled
   */
  HCAPTCHA_SITEKEY: import.meta.env.VITE_HCAPTCHA_SITEKEY as string,
  /**
   * Maximum number of replies a message can have
   */
  MAX_REPLIES: (import.meta.env.VITE_CFG_MAX_REPLIES as number) ?? 5,
  /**
   * Maximum number of attachments a message can have
   */
  MAX_ATTACHMENTS: (import.meta.env.VITE_CFG_MAX_ATTACHMENTS as number) ?? 5,
  /**
   * Maximum number of emoji a server can have
   */
  MAX_EMOJI: (import.meta.env.VITE_CFG_MAX_EMOJI as number) ?? 100,
  /**
   * Max file size allowed for uploads (in bytes)
   * 20 MB = 20 * 1024 * 1024 = 20,971,520 bytes
   * I kinda wonder if this should be a setting, or something fetched from the backend dynamically.
   */
  MAX_FILE_SIZE:
    (import.meta.env.VITE_CFG_MAX_FILE_SIZE as number) ?? 20_000_000,
  /**
   * Session ID to set during development.
   */
  DEVELOPMENT_SESSION_ID: import.meta.env.DEV
    ? (import.meta.env.VITE_SESSION_ID as string)
    : undefined,
  /**
   * Token to set during development.
   */
  DEVELOPMENT_TOKEN: import.meta.env.DEV
    ? (import.meta.env.VITE_TOKEN as string)
    : undefined,
  /**
   * User ID to set during development.
   */
  DEVELOPMENT_USER_ID: import.meta.env.DEV
    ? (import.meta.env.VITE_USER_ID as string)
    : undefined,
};
